import React from "react";
import { Card, Avatar, Button, Divider } from "antd";
import moment from "moment";
import liracrypt from "../Liracrypt/liracrypt";

const { Meta } = Card;

function CardComponent({ data, config }) {
  return (
    <>
     <div>
      asdfasdfasd
     </div>
      
    </>
  );
}

export default CardComponent;
